import { ReactElement } from 'react'
import { Fragment } from 'react'
import { useEnsuredUser } from '../../../Permissions/useEnsuredUser'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../root.reducer'

export const SmartTags = (): ReactElement => {
  const webUrl = useAppSelector(state => state.app.appProperties?.convIntelligenceWebUrl)
  const authHost = window.location.host
  const { t } = useTranslation()
  const user = useEnsuredUser()
  const sessionId = user.sessionId

  if (!webUrl) {
    return (
      <div></div>
    )
  } else {
    const iframeUrl = `${webUrl}/#/smartTag/?host=${authHost}&sid=${sessionId}`

    return (
      <Fragment>
        <iframe title={t('smartTags')} src={ iframeUrl } width={ '100%' } height={ '99%' } style={ { 'border': 0 } } />
      </Fragment>
    )
  }
}
